import { render, staticRenderFns } from "./AdRevenueEntry.vue?vue&type=template&id=c4a23660"
import script from "./AdRevenueEntry.vue?vue&type=script&lang=js"
export * from "./AdRevenueEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports